import type { Scorecard } from '@/types/analysis';

const CURVE_LENGTH = 12;

/** Act-structure modulation for 12-point curve. */
const ACT_MOD = [0.82, 0.86, 0.9, 0.94, 0.88, 0.92, 0.96, 1.0, 0.94, 0.97, 1.0, 0.98];

/**
 * Build attention curve from v7 sub-metrics (client-side fallback).
 * Server may also supply scorecard.attention_curve.
 */
export function computeAttentionCurve(scorecard: Scorecard | null | undefined): number[] | null {
  if (!scorecard) return null;
  if (Array.isArray(scorecard.attention_curve) && scorecard.attention_curve.length >= 3) {
    return scorecard.attention_curve.map((v) => Math.round(Number(v) * 10) / 10);
  }

  const v7 = scorecard.v7_scores ?? scorecard.v6_scores;
  if (!v7) return null;

  const seeds = [
    v7.etb_structure_pct,
    v7.pacing_pct,
    v7.story_beat_strength_pct,
    v7.scene_strength_pct,
    v7.concentration_pct,
    v7.character_resonance_pct,
  ].filter((v): v is number => typeof v === 'number' && !Number.isNaN(v));

  if (seeds.length < 3) return null;

  const points: number[] = [];
  for (let i = 0; i < CURVE_LENGTH; i++) {
    const seed = seeds[i % seeds.length];
    const mod = ACT_MOD[i] ?? 1;
    points.push(Math.round(Math.min(100, Math.max(0, seed * mod)) * 10) / 10);
  }
  return points;
}

export function isPreviewCurve(points: number[] | null | undefined, scorecard: Scorecard | null | undefined): boolean {
  if (!points?.length) return true;
  if (scorecard?.attention_curve?.length) return false;
  return true;
}
